export default __webpack_public_path__ + "static/media/i127hp.87d7428a.webp";